import React from 'react'

const AgentActivity = () => {
  return (
    <div>AgentActivity</div>
  )
}

export default AgentActivity